
// import React from "react";
// import { Link } from "react-router-dom";
// import defaultHero from "../assests/images/hero.jpg";

// function Hero({ text, text1, image }) {
//   return (
//     <section className="relative bg-black pt-28 pb-16 sm:pt-32 md:pt-36 md:pb-24 overflow-hidden">
//       <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between px-6 lg:px-8">

//         {/* ---------- Left Content ---------- */}
//         <div className="md:w-1/2 text-center md:text-left space-y-6 z-10">
//           <h2 className="text-orange-400 uppercase tracking-widest text-xs sm:text-sm font-semibold">
//             Transform Your Space with MF Blinds Carpet & Furniture
//           </h2>

//           <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight text-white drop-shadow-md">
//             <span className="text-orange-500">{text}</span>
//             <br className="hidden sm:block" />
//             <span className="text-blue-100">{text1}</span>
//           </h1>

//           <p className="text-blue-200 text-base sm:text-lg leading-relaxed max-w-md mx-auto md:mx-0">
//             Discover elegant blinds, luxurious carpets, and professional
//             installation services. Elevate your interiors with comfort, quality,
//             and craftsmanship — satisfaction guaranteed.
//           </p>

//           <div className="pt-4">
//             <Link to="/register">
//               <button className="bg-orange-600 hover:bg-orange-700 text-white px-8 py-3 rounded-full font-semibold shadow-lg hover:shadow-orange-600/30 transition-all duration-300">
//                 Get Started
//               </button>
//             </Link>
//           </div>
//         </div>

//         {/* ---------- Right Image ---------- */}
//         <div className="md:w-1/2 mt-10 md:mt-0 flex justify-center relative">
//           <div className="w-full max-w-md h-[340px] sm:h-[420px] rounded-3xl shadow-2xl border-4 border-orange-600 overflow-hidden transform hover:scale-105 transition-transform duration-500">
//             <img
//               src={defaultHero} // ✅ Dynamic image or fallback
//               alt="Hero visual"
//               className="w-full h-full object-cover"
//               loading="lazy"
//             />
//           </div>

//           {/* Decorative gradient glow behind image */}
//           <div className="absolute -bottom-8 -right-8 w-48 h-48 bg-orange-500/30 blur-3xl rounded-full -z-10"></div>
//         </div>
//       </div>

//       {/* ---------- Background Glows ---------- */}
//       <div className="absolute top-0 left-0 w-72 h-72 bg-orange-500/20 blur-3xl rounded-full -z-10"></div>
//       <div className="absolute bottom-0 right-0 w-72 h-72 bg-blue-700/20 blur-3xl rounded-full -z-10"></div>
//     </section>
//   );
// }

// export default Hero;

// green attempt

// import React from "react";
// import { Link } from "react-router-dom";
// import defaultHero from "../assests/images/hero.jpg";

// function Hero({ text, text1, image }) {
//   return (
//   //  <section className="relative bg-white pt-28 pb-16 sm:pt-32 md:pt-36 md:pb-24 overflow-hidden">
//  <section className="relative bg-white p-2 mt-2 overflow-hidden">

//   <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between px-6 lg:px-8">

//     {/* ---------- Left Content ---------- */}
//     <div className="md:w-1/2 text-center md:text-left space-y-6 z-10">
//       <h2 className="text-green-600 uppercase tracking-widest text-xs sm:text-sm font-semibold">
//         Transform Your Space with MF Blinds Carpet & Furniture
//       </h2>

//       <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight text-gray-900 drop-shadow-md">
//         <span className="text-green-700 ">{text}</span>
//         <br className="hidden sm:block" />
//         <span className="text-teal-600 text-4xl sm:text-xl">{text1}</span>
//       </h1>

//       <p className="text-gray-700 text-base sm:text-lg leading-relaxed max-w-md mx-auto md:mx-0">
//         Discover elegant blinds, luxurious carpets, and professional
//         installation services. Elevate your interiors with comfort, quality,
//         and craftsmanship — satisfaction guaranteed.
//       </p>

//       <div className="pt-4">
//         <Link to="/register">
//           <button className="bg-green-600 hover:bg-green-700 text-white px-8 py-3 rounded-full font-semibold shadow-lg hover:shadow-green-600/30 transition-all duration-300">
//             Get Started
//           </button>
//         </Link>
//       </div>
//     </div>

//     {/* ---------- Right Image ---------- */}
//     <div className="md:w-1/2 mt-14 md:mt-0 flex justify-center relative">
//       <div className="w-full max-w-md mt-2 h-[340px] sm:h-[420px] rounded-3xl shadow-2xl border-4 border-green-600 overflow-hidden transform hover:scale-105 transition-transform duration-500">
//         <img
//           src={defaultHero} // dynamic image or fallback
//           alt="Hero visual"
//           className="w-full h-full object-cover"
//           loading="lazy"
//         />
//       </div>

//       {/* Decorative gradient glow behind image */}
//       <div className="absolute -bottom-8 -right-8 w-48 h-48 bg-green-500/30 blur-3xl rounded-full -z-10"></div>
//     </div>
//   </div>

//   {/* ---------- Background Glows ---------- */}
//   <div className="absolute top-0 left-0 w-72 h-72 bg-green-500/20 blur-3xl rounded-full -z-10"></div>
//   <div className="absolute bottom-0 right-0 w-72 h-72 bg-teal-400/20 blur-3xl rounded-full -z-10"></div>
//    </section>

//   );
// }

// export default Hero;


import React from "react";
import { Link } from "react-router-dom";
import defaultHero from "../assests/images/rightimage.png";

function Hero({ text, text1, image }) {
  return (
    <section className="relative bg-white  mt-12 overflow-hidden">
   <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between px-6 lg:px-8">

  {/* ---------- Left Content ---------- */}
  <div className="md:w-1/2 text-center md:text-left mt-8 space-y-6 z-10">
    {/* Subheading */}
    <h2 className="text-lime-500 uppercase tracking-widest text-xs sm:text-sm font-semibold font-sans">
      Transform Your Space with MF Blinds Carpet & Furniture
    </h2>

    {/* Main Heading */}
    <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.15] text-gray-900 drop-shadow-md space-y-1 font-heading" style={{ fontFamily: "'Playfair Display', serif" }}>
      <span className="block text-lime-600">
        {text}
      </span>

      <span className="block text-teal-600 text-2xl sm:text-3xl lg:text-3xl mt-1 font-semibold">
        {text1}
      </span>
    </h1>

    {/* Paragraph */}
    <p className="text-gray-700 text-base sm:text-lg leading-relaxed max-w-md mx-auto md:mx-0 font-body" style={{ fontFamily: "'Inter', sans-serif" }}>
      Discover elegant blinds, luxurious carpets, and professional
      installation services. Elevate your interiors with comfort, quality,
      and craftsmanship — satisfaction guaranteed.
    </p>

    {/* CTA Button */}
    <div className="pt-4">
      <Link to="/register">
        <button className="bg-lime-600 hover:bg-lime-700 text-white px-8 py-3 rounded-full font-semibold shadow-lg hover:shadow-lime-600/30 transition-all duration-300">
          Get Started
        </button>
      </Link>
    </div>
  </div>

  {/* ---------- Right Image ---------- */}
  <div className="md:w-1/2 mt-10 md:mt-0 flex justify-center relative">
    <div className="w-full max-w-sm sm:max-w-md h-[260px] sm:h-[330px] rounded-3xl shadow-2xl border-4 border-lime-600 overflow-hidden transform hover:scale-105 transition-transform duration-500">
      <img
        src={image || defaultHero}
        alt="Hero visual"
        className="w-full h-full object-cover"
        loading="lazy"
      />
    </div>

    <div className="absolute -bottom-6 -right-6 w-32 h-32 sm:w-40 sm:h-40 bg-lime-500/30 blur-3xl rounded-full -z-10"></div>
  </div>

</div>


      {/* ---------- Background Glows ---------- */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-lime-500/20 blur-3xl rounded-full -z-10"></div>
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-teal-400/20 blur-3xl rounded-full -z-10"></div>
    </section>
  );
}

export default Hero;
